import React, { useState } from 'react';
import './Navbar.css';
import HelpModal from './modals/HelpModal';
import AboutModal from './modals/AboutModal';

const Navbar = ({ children }) => {
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);

  return (
    <>
      <nav className="myNav navbar navbar-default" role="navigation">
        <div className="container-fluid">
          <div className="navbar-header">
            <a className="navbar-brand" href="/">
              <img 
                src="https://raw.githubusercontent.com/MIMBCD-UI/prototype-breast-screening/master/assets/banner-white.png" 
                alt="MIMBCD-UI"
              />
            </a>
            <div className="navbar-brand assistivenavTitle">
              <span className="navbar-brand-text">
                BreastScreening-AI
              </span>
            </div>
          </div>
          <div className="navbar-left" style={{ marginLeft: '20px', display: 'flex', alignItems: 'center', height: '50px' }}>
            <button 
              className="btn btn-default navbar-btn"
              onClick={() => setShowHelpModal(true)}
              style={{ marginRight: '10px' }}
            >
              Help
            </button>
            <button 
              className="btn btn-default navbar-btn"
              onClick={() => setShowAboutModal(true)}
            >
              About
            </button>
          </div>
        </div>
      </nav>

      {/* Help Modal */}
      {showHelpModal && (
        <HelpModal onClose={() => setShowHelpModal(false)} />
      )}

      {/* About Modal */}
      {showAboutModal && (
        <AboutModal onClose={() => setShowAboutModal(false)} />
      )}
    </>
  );
};

export default Navbar;
